import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    OnInit,
    output,
    ViewEncapsulation,
    model,
} from '@angular/core';
import {
    IOnboardingReportData,
    IOnboardingReportWidget,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import {
    FiOnboardingReportGroupType,
    FiOnboardingReportType,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-enums';
import { Observable } from 'rxjs';
import { FiOnboardingReportDateService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-date.service';
import { FiReportWidgetDialogsService } from '@fi-shared/fi-report-widget/fi-report-widget-dialogs.service';

@Component({
    selector: 'fi-onboarding-report-widget',
    templateUrl: './fi-onboarding-report-widget.component.html',
    styleUrl: './fi-onboarding-report-widget.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-report-widget' },
    standalone: false,
})
export class FiOnboardingReportWidgetComponent implements OnInit {
    public widget = model<IOnboardingReportWidget>();
    public reportData = input.required<IOnboardingReportData>();
    public updateWidget = output<IOnboardingReportWidget>();
    public deleteWidget = output<IOnboardingReportWidget>();

    private fiOnboardingReportDateService = inject(FiOnboardingReportDateService);
    private fiReportWidgetDialogsService = inject(FiReportWidgetDialogsService);
    private fiStateService = inject(FiStateService);

    public ngOnInit(): void {
        this.fiOnboardingReportDateService.resetDateRange(this.widget().Id);
    }

    protected openWidget(isFilterExpanded: boolean): void {
        this.fiStateService.go(FiStateNames.Onboarding.Report.Widget._name, {
            id: this.widget().Id,
            isFilterExpanded: isFilterExpanded,
        });
    }

    protected openRenameWidgetDialog(): void {
        this.fiReportWidgetDialogsService
            .getRenameWidgetDialog(this.widget().Name, this.widget().Description)
            .onYesButtonClick((result) => {
                this.widget.update((w) => ({
                    ...w,
                    Name: result.widgetName,
                    Description: result.widgetDescription,
                }));
                this.updateWidget.emit(this.widget());
            });
    }

    protected openDeleteWidgetDialog(): void {
        this.fiReportWidgetDialogsService.getConfirmWidgetDeleteDialog().onYesButtonClick(() => {
            this.deleteWidget.emit(this.widget());
        });
    }

    protected readonly FiOnboardingReportGroupType = FiOnboardingReportGroupType;
    protected readonly FiOnboardingReportType = FiOnboardingReportType;
}
